import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { SegmentExport } from '@feathr/blackbox';
import { Button, EmptyState, Table } from '@feathr/components';
import Page from '@feathr/extender/App/Page';
import { useLocalUrl, useStore } from '@feathr/extender/state';

import dataExportsColumns from './dataExportsColumns';

function DataExportsPage(): JSX.Element {
  const { SegmentExports } = useStore();
  const { t } = useTranslation();
  const localUrl = useLocalUrl();

  const segmentExports = SegmentExports.list();
  const hasExports = segmentExports.models.length > 0;

  return (
    <Page
      collapseHeader={false}
      collapseHeaderOnScroll={true}
      description={t(
        'View export progress, download completed files, and manage past exports. Exports are started from the Groups page.',
      )}
      title={t('Exports')}
    >
      {hasExports || segmentExports.isPending ? (
        <Table<SegmentExport>
          collection={SegmentExports}
          columns={dataExportsColumns([], t)}
          initialSort={[{ id: 'date_created', desc: true }]}
          isLoading={segmentExports.isPending}
        />
      ) : (
        <EmptyState
          description={t('Export one to get started.')}
          height={'full'}
          label={t('No exports found.')}
          name={'data-exports-empty-state'}
          theme={'white'}
          width={'full'}
        >
          <Button link={localUrl('/data/segments')} type={'primary'}>
            {t('Go to Groups')}
          </Button>
        </EmptyState>
      )}
    </Page>
  );
}

export default observer(DataExportsPage);
